<template lang="pug">
	li.sidenav-menu__item
		div(:class="{ 'sidenav-menu__item--toggle' : $slots.children }")
			a.sidenav-menu__button.md-button.md-ink-rippl(href="/hitelek")
				slot
			button.sidenav-menu__dropdown-wrapper(v-if="$slots.children", @click="toggleOpen", aria-haspopup="true")
				span.icon--dropdown.icon-arrow-up(:class="{'icon--dropdown--is-open' : opened}")
		slot(v-if="opened", name="children")
</template>
<script>
export default {
	data: () => ({
		opened: false
	}),
	props: {
		href: {
			required: true,
			type: String
		}
	},
	methods: {
		toggleOpen() {
			this.opened = !this.opened;
		}
	}
};
</script>
